import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from '../TaskDetails.style';

export const DayFiveCheckInDetails = () => {
  const {ts} = useTranslation(
    'clientProfile.clientJourney.firstWeek.dayFiveCheckIn',
  );

  return (
    <>
      <View
        style={{
          ...styles.taskDetailContent,
          ...styles.dayFiveTaskDetailsContent,
        }}>
        <Text
          variant="button"
          style={styles.taskDetailContentText}
          {...testProperties(DownlineProfile.cjTaskDetailsText)}>
          {ts(
            'details',
            'If your Client has entered fat burn, they may be feeling energized and excited to keep up with the benefits of their new routines. Use your best judgment to decide whether they still need daily support and reiterate the questions and encouragement above as required.',
          )}
        </Text>
      </View>
      <View style={styles.dayFiveDescription}>
        <Text
          variant="button"
          style={styles.taskDetailContentText}
          {...testProperties(DownlineProfile.cjTaskDetailsSecondText)}>
          {ts(
            'details',
            'After the first week, check in and schedule the first Week celebration call with your Training Coach or Support Team member.',
          )}
        </Text>
      </View>
    </>
  );
};
